import { forumActions } from './ForumAction';
import { courseActions } from '../../CourseActions';
import stripHTML from 'imports/strip-html';

const initState = {
    loadingFlags: {
        "course": true,
    },
    errors: {},
    discussionsListId: [],
    selectedDiscussion: null,
    selectedTopic: null,
    selectedPostIdToEdit: null,
    topicList: [],
    cancelTokenSources: {},
    postForm: {
        reply: null,
        postContent: null,
        attachments: []
    },
    activeTopic: null,
    isSearchState: false,
    searchResult: {
        posts: [],
        discussions: [],
    },
    users: [],
    showSearchUser: false,
    searchSpinner: false,
    mentionedStudents: [],
}

export default function forumPageReducer(state=initState, action) {
    switch (action.type) {
        case forumActions.setQuizStatus:
            return setQuizStatus(state, action);
        case forumActions.setError:
            return setError(state, action);
        case forumActions.toggleSpinner:
            return toggleSpinner(state, action);
        case forumActions.toggleSelectTopic:
            return toggleSelectTopic(state, action);
        case forumActions.setDiscussionsList:
            return setDiscussionsList(state, action);
        case forumActions.addCancelTokenSource:
            return addCancelTokenSource(state, action);
        case forumActions.postFormSetReply:
            return postFormSetReply(state, action);
        case forumActions.postFormClearReply:
            return postFormClearReply(state, action);
        case forumActions.postFormSetContent:
            return postFormSetContent(state, action);
        case forumActions.postFormClearContent:
            return postFormClearContent(state, action);
        case forumActions.setSelectedPostIdToEdit:
            return setSelectedPostIdToEdit(state, action);
        case forumActions.setSelectedDiscussion:
            return setSelectedDiscussion(state, action);
        case forumActions.postFormSetAttachments:
            return postFormSetAttachments(state, action);
        case forumActions.postFormClearAttachments:
            return postFormClearAttachments(state, action);
        case forumActions.deletePostFormAttachment:
            return deletePostFormAttachment(state, action);
        case forumActions.setTopicList:
            return setTopicList(state, action);
        case forumActions.setActiveTopic:
            return setActiveTopic(state, action);
        case courseActions.toggleSearchState:
            return toggleSearchState(state, action);
        case forumActions.setSearchResult:
            return setSearchResult(state, action);
        case forumActions.setUsersList:
            return setUsersList(state, action)
        case forumActions.setMentionedStudents:
            return setMentionedStudents(state, action)
        case forumActions.toggleShowSearchUser:
            return toggleShowSearchUser(state, action)
        case forumActions.hideShowSearchUser:
            return hideShowSearchUser(state)
        case forumActions.removeMentionedUser:
            return removeMentionedUser(state, action)
        default:
            return state;
    }
}

function setSearchResult(state, {payload}) {
    return {
        ...state,
        searchResult: {
            posts: payload.posts.map(item => {
                return {
                    discussionId: item['discussion_uid'],
                    topicId: item['topic_uid'],
                    postId: item['uid'],
                    name: `${item['user_info']['first_name']} ${item['user_info']['last_name']}`,
                    role: item['user_info']['role'],
                    dateTime: item['created'],
                    title: stripHTML(item['content']).trunc(25, true),
                }
            }),
            discussions: payload.discussions.map((item) => {
                return {
                    discussionId: item['uid'],
                    topicId: item['topic_uid'],
                    title: item['title'],
                    name: `${item['user_info']['first_name']} ${item['user_info']['last_name']}`,
                    role: item['user_info']['role'],
                    dateTime: item['created'],
                }
            }),
        }
    }
}


function toggleSearchState(state, {payload}) {
    return {
        ...state,
        isSearchState: payload,
    }
}

function setActiveTopic(state, {payload}) {
    return {
        ...state,
        activeTopic: payload,
    }
}

function setTopicList(state, {payload}) {
    return {
        ...state,
        topicList: payload
    }
}

function deletePostFormAttachment(state, { payload }) {
    const filteredAttachments = state.postForm.attachments.filter(a => {
        return a.id !== payload;
    })
    return {
        ...state,
        postForm: {
            ...state.postForm,
            attachments: filteredAttachments,
        }
    }
}

function postFormSetAttachments(state, { payload }) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            attachments: payload,
        }
    }
}

function postFormClearAttachments(state) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            attachments: []
        }
    }
}

function setSelectedDiscussion(state, { payload }) {
    return {
        ...state,
        selectedDiscussion: payload || null,
    }
}

function setSelectedPostIdToEdit(state, {payload}) {
    const selectedPostIdToEdit = payload || null;
    return {
        ...state,
        selectedPostIdToEdit,
    }
}

function postFormSetReply(state, {payload}) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            reply: payload,
        }
    }
}

function postFormClearReply(state) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            reply: null,
        }
    }
}

function postFormSetContent(state, {payload}) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            postContent: payload,
        }
    }
}

function postFormClearContent(state) {
    return {
        ...state,
        postForm: {
            ...state.postForm,
            postContent: '',
        }
    }
}


function addCancelTokenSource(state, {payload, meta}) {
    return {
        ...state,
        cancelTokenSources: {
            ...state.cancelTokens,
            [meta.id]: payload 
        }
    }
}

function setDiscussionsList(state, {payload}) {
    return {
        ...state,
        discussionsListId: payload
    }
}

function toggleSelectTopic(state, {payload}) {
    if (payload.state) {
        return {
            ...state,
            selectedTopic: payload.id
        }
    } else {
        return {
            ...state,
            selectedTopic: null
        }
    }
}

function setQuizStatus(state, {payload}) {
    return {
        ...state,
        quizStatus: payload
    }
}

function setError(state, {payload, meta}) {
    return {
        ...state,
        errors: {
            [meta.apiName]: payload
        },
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.loadingFlags,
            [meta.apiName]: payload,
        },
    }
}

function setUsersList(state, { payload }) {
    return {
        ...state,
        users: payload,
    }
}

function setMentionedStudents(state, { payload }) {
    return {
        ...state,
        mentionedStudents: payload
    }
}

function toggleShowSearchUser(state, { payload }) {
    return {
        ...state,
        showSearchUser: payload
    }
}

function hideShowSearchUser(state) {
    return {
        ...state,
        showSearchUser: false
    }
}

function removeMentionedUser(state, { payload }) {
    return {
        ...state,
        mentionedStudents: payload
    }
}
